import React, { useState, useEffect } from "react";
import "../../styles/App.css";

function SwitchCompanyModal({
  isOpen,
  onClose,
  apiKeys = [],
  currentApiKey = "",
  onCompanyChange,
  showSplashThen,
}) {
  const [selectedKey, setSelectedKey] = useState(
    typeof currentApiKey !== "undefined" && currentApiKey !== null
      ? String(currentApiKey)
      : ""
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setSelectedKey(
      typeof currentApiKey !== "undefined" && currentApiKey !== null
        ? String(currentApiKey)
        : ""
    );
  }, [currentApiKey, isOpen]);

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.height = "100%";

      document.documentElement.style.overflow = "hidden";

      const preventScroll = (e) => {
        if (!e.target.closest(".switch-company-modal")) {
          e.preventDefault();
        }
      };

      document.addEventListener("touchmove", preventScroll, { passive: false });
      document.addEventListener("wheel", preventScroll, { passive: false });

      return () => {
        document.removeEventListener("touchmove", preventScroll);
        document.removeEventListener("wheel", preventScroll);
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.body.style.height = "";
        document.documentElement.style.overflow = "";

        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedKey && selectedKey !== currentApiKey) {
      setIsLoading(true);
      onClose();

      if (showSplashThen) {
        showSplashThen(() => {
          onCompanyChange(selectedKey);
          setIsLoading(false);
        }, 600);
      } else {
        onCompanyChange(selectedKey);
        setIsLoading(false);
      }
    } else {
      onClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="switch-company-modal">
        <div className="modal-header">
          <h3>Switch Company</h3>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            Select a company to switch to. All data and reports will update to
            reflect the selected company.
          </p>

          <div className="company-list">
            {apiKeys.length === 0 ? (
              <div className="no-companies">
                <p>No companies available</p>
              </div>
            ) : (
              apiKeys.map((item, idx) => {
                const comp = item.company || item;
                const rawKey =
                  item.api_key || comp.api_key || comp.id || comp?.id;
                const keyStr =
                  typeof rawKey !== "undefined" && rawKey !== null
                    ? String(rawKey)
                    : "";
                const name = comp?.name || keyStr;
                const description = comp?.description;
                const subscription_status = comp?.subscription_status;
                return (
                  <div
                    key={keyStr || idx}
                    className={`company-item ${
                      selectedKey === keyStr ? "selected" : ""
                    }`}
                    onClick={() => setSelectedKey(keyStr)}
                  >
                    <div className="company-radio">
                      <input
                        type="radio"
                        name="company"
                        value={keyStr}
                        checked={selectedKey === keyStr}
                        onChange={() => setSelectedKey(keyStr)}
                      />
                    </div>
                    <div className="company-info">
                      <div className="company-name">{name}</div>
                      {description && (
                        <div className="company-description">{description}</div>
                      )}
                      {selectedKey === keyStr && (
                        <div className="current-badge">Current</div>
                      )}
                    </div>
                    <div className="company-status">
                      {subscription_status && (
                        <span
                          className={`status-badge ${String(
                            subscription_status
                          ).toLowerCase()}`}
                        >
                          {subscription_status}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={
              !selectedKey || selectedKey === currentApiKey || isLoading
            }
          >
            {isLoading ? (
              <>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="loading-spinner"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeDasharray="31.416"
                    strokeDashoffset="31.416"
                    fill="none"
                  />
                </svg>
                Switching...
              </>
            ) : (
              "Switch Company"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SwitchCompanyModal;
